const SET_MESSAGE = '[messages][general]set.message';
const CLEAR_MESSAGES = '[messages][general]clear';

export {SET_MESSAGE, CLEAR_MESSAGES}